module.exports = __webpack_public_path__ + "img/Image.f4bd1029.png";